<template>
	<div class="container" v-if="page !== null">
		<section class="section">
			<component class="content fr-view" v-bind:is="template"></component>
		</section>
	</div>
	<loader v-else></loader>
</template>

<style scoped>
.container {
  max-width: 1000px;
  padding: 0% 5% 0% 5%;
}
</style>
<script>
import Loader from './Loader';

export default {
  components: {
    Loader,
  },

  name: 'page-view',

  created() {
    this.loadPage();
  },

  watch: {
    $route() {
      this.loadPage();
    },
  },

  computed: {
    page() {
      return this.$store.state.page.page;
    },

    loading() {
      return this.$store.state.page.loading;
    },

    template() {
      return {
        template: '<div>' + this.$store.state.page.page.content + '</div>',
      };
    },
  },

  methods: {
    loadPage() {
      this.$store.commit('progress/start');

      this.$store.dispatch('page/load', this.$route.params.id).then(() => {
        this.$store.commit('progress/stop');
        scroll(0, 0);
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageView.vue